<p-card color="indigo">
  <p-panel header="Details" [toggleable]="true" [collapsed]="true">
    <p>{{ config.data }}</p>
  </p-panel>
</p-card>
